export default __webpack_public_path__ + "media/images/icons/tag-c7e7b3c54e62228e8cc561a29c551826.svg";